var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDoubleCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2222 1C15.9188 1 10.8313 3.10712 7.07916 6.857C3.32915 10.609 1.22212 15.6961 1.22212 20.9999C1.22212 26.3038 3.32925 31.3907 7.07916 35.1428C10.8311 38.8928 15.9183 40.9998 21.2222 40.9998C26.5261 40.9998 31.6131 38.8927 35.3652 35.1428C39.1152 31.3909 41.2222 26.3038 41.2222 20.9999C41.2222 15.6961 39.1151 10.6091 35.3652 6.857C31.6132 3.10702 26.5261 1 21.2222 1ZM21.2222 32.111C18.2757 32.111 15.4484 30.9404 13.3649 28.8571C11.2813 26.7738 10.1109 23.9464 10.1109 20.9998C10.1109 18.0533 11.2816 15.2261 13.3649 13.1426C15.4482 11.059 18.2756 9.88865 21.2222 9.88865C24.1687 9.88865 26.9959 11.0593 29.0795 13.1426C31.163 15.2259 32.3334 18.0533 32.3334 20.9998C32.3334 23.9464 31.1628 26.7735 29.0795 28.8571C26.9962 30.9406 24.1687 32.111 21.2222 32.111Z",
    fill: "#585858",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6644 21.0045C25.6644 23.4588 23.6743 25.4489 21.22 25.4489C18.7656 25.4489 16.7756 23.4588 16.7756 21.0045C16.7756 18.5501 18.7656 16.5601 21.22 16.5601C23.6743 16.5601 25.6644 18.5501 25.6644 21.0045Z",
    fill: "#585858"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleCircle);
export default __webpack_public_path__ + "static/media/double-circle.115ca486eb4551abe6491bcc5f079107.svg";
export { ForwardRef as ReactComponent };